import {
    FacebookShareButton,
    FacebookIcon,
    LinkedinShareButton,
    TelegramShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    WhatsappIcon,
    LinkedinIcon,
    TelegramIcon,
    XIcon,
  } from "react-share";

export default function Share({
    shareUrl,
    size = 35,
}) {
    return (
        <div id="share">
            <WhatsappShareButton className="wa_background" url={shareUrl}>
                <WhatsappIcon size={size} />
            </WhatsappShareButton>

            <LinkedinShareButton className="li_background" url={shareUrl}>
                <LinkedinIcon size={size} />
            </LinkedinShareButton>

            <TelegramShareButton className="tg_background" url={shareUrl}>
                <TelegramIcon size={size} />
            </TelegramShareButton>

            <FacebookShareButton className="fb_background" url={ shareUrl}>
                <FacebookIcon size={size} />
            </FacebookShareButton>

            <TwitterShareButton className="tt_background" url={shareUrl}>
                <XIcon size={size} />
            </TwitterShareButton>

            <style global jsx>{`
                #share {
                    position: fixed;
                    top: 50%;
                    bottom: 50%;
                    left: 0;
                    display: flex;
                    flex-direction: column;
                    z-index: 50;
                }

                #share button {
                    padding: 2px !important;
                }

                #share .wa_background {
                    background-color: #25D366 !important;
                }

                #share .li_background {
                    background-color: #0077B5 !important;
                }

                #share .tg_background {
                    background-color: #25A3E3 !important;
                }

                #share .fb_background {
                    background-color: #0965FE !important;
                }

                #share .tt_background {
                    background-color: #000000 !important;
                }

                @media screen and (max-width: 780px) {
                    #share {
                        bottom: 0;
                        top: auto;
                        flex-direction: row;
                        width: 100%;
                    }

                    #share > button {
                        flex: 1 1 auto;
                    }
                }
            `}</style>
        </div>
    );
}